import { Link, useLocation } from "react-router-dom";
import { BarChart3, FileText, Grid, MessageSquare, Settings, Users, Upload } from "lucide-react";
import { cn } from "@/lib/utils";

interface NavItem {
  label: string;
  href: string;
  icon: React.ElementType;
}

interface AdminSidebarProps {
  onItemClick?: () => void;
}

const AdminSidebar = ({ onItemClick }: AdminSidebarProps) => {
  const location = useLocation();
  
  const navigationItems: NavItem[] = [
    {
      label: "Dashboard",
      href: "/settings",
      icon: Grid,
    },
    {
      label: "Quotes",
      href: "/settings/quotes",
      icon: FileText,
    },
    {
      label: "Categories",
      href: "/settings/categories",
      icon: BarChart3,
    },
    {
      label: "Subscribers",
      href: "/settings/subscribers",
      icon: Users,
    },
    {
      label: "Message Logs",
      href: "/settings/logs",
      icon: MessageSquare,
    },
    {
      label: "Settings",
      href: "/settings/system",
      icon: Settings,
    },
  ];
  
  return (
    <div className={cn(
      "bg-white h-full", 
      "md:w-64 md:border-r md:border-gray-200"
    )}>
      <div className="py-6 px-3">
        <div className="mb-8 px-4 md:block hidden">
          <h2 className="text-xl font-bold text-gray-800">Quote Admin</h2>
        </div>
        
        <nav className="space-y-1">
          {navigationItems.map((item) => {
            const isActive = location.pathname === item.href || 
                           (item.href !== "/settings" && location.pathname.startsWith(item.href));
                           
            return (
              <Link
                key={item.href}
                to={item.href}
                className={cn(
                  "flex items-center px-4 py-3 text-sm font-medium rounded-md",
                  isActive
                    ? "bg-primary-50 text-primary-600"
                    : "text-gray-700 hover:bg-gray-100"
                )}
                onClick={onItemClick}
              >
                <item.icon className={cn(
                  "mr-3 h-5 w-5",
                  isActive ? "text-primary-500" : "text-gray-500"
                )} />
                {item.label}
              </Link>
            );
          })}
        </nav>
      </div>
    </div>
  );
};

export default AdminSidebar;
